import { z } from 'zod'

// Identity смотрящего — сотрудник stit (заказчиков в хабе нет). Источник —
// GET /api/employees/me (employee-backend): huma-обёртка {data: EmployeeView}.
// role: 'admin' гейтит мутации реквизитов/видимости и деактивацию сотрудников.

export const EmployeeMeSchema = z.object({
  id: z.string(),
  subject: z.string(),
  username: z.string(),
  full_name: z.string(),
  email: z.string(),
  role: z.string(),
  is_active: z.boolean(),
  timezone: z.string().default(''),
  version: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
})

export type EmployeeMe = z.infer<typeof EmployeeMeSchema>

// Wire-обёртка ответа /employees/me ({$schema} игнорируется — object не strict).
export const EmployeeMeResponseSchema = z.object({ data: EmployeeMeSchema })

export interface Session {
  id: string
  username: string
  fullName: string
  email: string
  role: string
  isActive: boolean
  isAdmin: boolean
  // Зона, которую хаб видел последней. Нужна ровно для сверки с устройством:
  // показ времени её не спрашивает — он всегда берёт зону устройства.
  timezone: string
}

export function sessionFromMe(me: EmployeeMe): Session {
  const role = me.role || 'employee'
  return {
    id: me.id,
    username: me.username,
    fullName: me.full_name || me.username,
    email: me.email,
    role,
    isActive: me.is_active,
    isAdmin: role === 'admin',
    timezone: me.timezone,
  }
}
